module.exports = __webpack_public_path__ + "media/flags/at-cade06b2.svg";